module.exports = __webpack_public_path__ + "static/img/bg_reward_item_black.292d75a6.svg";